import { Event } from '@/types/Event';

/**
 * Converts a Unix timestamp (milliseconds) to ICS date format (YYYYMMDDTHHMMSSZ)
 */
const formatIcsDate = (timestamp: number): string => {
    const date = new Date(timestamp);
    const year = date.getUTCFullYear();
    const month = String(date.getUTCMonth() + 1).padStart(2, '0');
    const day = String(date.getUTCDate()).padStart(2, '0');
    const hours = String(date.getUTCHours()).padStart(2, '0');
    const minutes = String(date.getUTCMinutes()).padStart(2, '0');
    const seconds = String(date.getUTCSeconds()).padStart(2, '0');

    return `${year}${month}${day}T${hours}${minutes}${seconds}Z`;
};

/**
 * Escapes special characters in ICS file content
 */
const escapeIcsText = (text: string): string => {
    return text.replace(/\\/g, '\\\\').replace(/;/g, '\\;').replace(/,/g, '\\,').replace(/\n/g, '\\n');
};

/**
 * Generates an ICS file content string from an Event object
 * Follows RFC 5545 iCalendar standard
 */
export const generateIcsFile = (event: Event): string => {
    const startDate = formatIcsDate(event.startTime);
    const endDate = formatIcsDate(event.endTime);
    const timestamp = formatIcsDate(Date.now());

    // Generate a unique identifier for the event
    const uid = `${event.startTime}-${Math.random().toString(36).substring(2, 9)}@liveauctioneers.com`;

    const icsContent = [
        'BEGIN:VCALENDAR',
        'VERSION:2.0',
        'PRODID:-//LiveAuctioneers//Auction Calendar//EN',
        'CALSCALE:GREGORIAN',
        'METHOD:PUBLISH',
        'BEGIN:VEVENT',
        `UID:${uid}`,
        `DTSTAMP:${timestamp}`,
        `DTSTART:${startDate}`,
        `DTEND:${endDate}`,
        `SUMMARY:${escapeIcsText(event.title)}`,
        `DESCRIPTION:${escapeIcsText(event.description)}`,
        `LOCATION:${escapeIcsText(event.location)}`,
        'STATUS:CONFIRMED',
        'SEQUENCE:0',
        'END:VEVENT',
        'END:VCALENDAR',
    ].join('\r\n');

    return icsContent;
};
